export enum MappingSidebarType {
  ItemMapping = 'itemMapping',
  FirstTimeMapping = 'firstTimeMapping',
}
